import { api, MEMBER_API_SUB_URLS } from '@/api';
import { AxiosResponse } from 'axios';
import { Module } from 'vuex';
import {
  RootState,
  MemberCustomerServiceInfoResponseModel,
} from '@/@types/member';

interface CustomerServiceState {
  customerServiceInformation: MemberCustomerServiceInfoResponseModel;
}

const CUSTOMER_SERVICE_STATE: Module<CustomerServiceState, RootState> = {
  state: {
    customerServiceInformation: null,
  },
  actions: {
    // UC-REST-004 - Get Member Customer Service Information
    getMemberCustomerServiceInformation(context): Promise<AxiosResponse> {
      return api
        .get(
          `${MEMBER_API_SUB_URLS.members}/${
            context.getters.user.memberId
          }/customer-service-info`,
        )
        .then((customerServiceInfo) => {
          context.commit('setCustomerServiceInfo', customerServiceInfo.data);
          return customerServiceInfo.data;
        });
    },
  },
  mutations: {
    setCustomerServiceInfo(
      state: CustomerServiceState,
      data: MemberCustomerServiceInfoResponseModel,
    ) {
      state.customerServiceInformation = data;
    },
  },
  getters: {
    customerServiceInformation(state): MemberCustomerServiceInfoResponseModel {
      return state.customerServiceInformation;
    },
    groupHours(state): string {
      return state.customerServiceInformation.hours;
    },
    groupTollFreePhone(state): string {
      return state.customerServiceInformation.phoneNumber;
    },
    groupEmail(state): string {
      return state.customerServiceInformation.emailMessage;
    },
    groupBrandName(state): string {
      return state.customerServiceInformation.brandName;
    },
    groupMainSiteURL(state): string {
      return state.customerServiceInformation.url;
    },
  },
};

export default CUSTOMER_SERVICE_STATE;
